/**
 * gmbCategoryLabels.generated.ts — Mapa slug GMB (inglés) → etiqueta ES.
 *
 * GENERADO desde el catálogo bilingüe del backend
 * (backend/.../gmb_categories_catalog.json, 90 entradas oficiales GMB).
 * Copia de datos PÚBLICOS para traducir EN→ES en el frontend sin round-trip ni
 * cambio de backend. Si el catálogo del backend cambia, regenerar este archivo.
 * No editar a mano.
 */
export const GMB_CATEGORY_ES: Record<string, string> = {
  "accountant": "Contable",
  "advertising_agency": "Agencia de publicidad",
  "auto_parts_store": "Tienda de repuestos de coche",
  "bakery": "Panadería",
  "bank": "Banco",
  "bar": "Bar",
  "barber_shop": "Barbería",
  "beauty_salon": "Salón de belleza",
  "book_store": "Librería",
  "business_management_consultant": "Consultor de gestión empresarial",
  "butcher_shop": "Carnicería",
  "cafe": "Cafetería",
  "car_dealer": "Concesionario de coches",
  "car_repair": "Taller de coches",
  "car_wash": "Lavado de coches",
  "carpenter": "Carpintero",
  "certified_public_accountant": "Auditor de cuentas",
  "chiropractor": "Quiropráctico",
  "cleaning_service": "Servicio de limpieza",
  "clothing_store": "Tienda de ropa",
  "convenience_store": "Tienda de conveniencia",
  "courier_service": "Servicio de mensajería",
  "day_care_center": "Centro de día",
  "dentist": "Dentista",
  "doctor": "Médico",
  "driving_school": "Autoescuela",
  "dry_cleaner": "Tintorería",
  "electrician": "Electricista",
  "electronics_store": "Tienda de electrónica",
  "employment_consultant": "Asesor laboral",
  "event_venue": "Salón de eventos",
  "fast_food_restaurant": "Restaurante de comida rápida",
  "financial_consultant": "Asesor financiero",
  "fitness_center": "Centro de fitness",
  "florist": "Floristería",
  "funeral_home": "Funeraria",
  "furniture_store": "Tienda de muebles",
  "general_contractor": "Contratista de obras",
  "graphic_designer": "Diseñador gráfico",
  "grocery_store": "Tienda de comestibles",
  "gym": "Gimnasio",
  "hair_salon": "Peluquería",
  "hardware_store": "Ferretería",
  "hotel": "Hotel",
  "hvac_contractor": "Instalador de climatización",
  "ice_cream_shop": "Heladería",
  "insurance_agency": "Agencia de seguros",
  "italian_restaurant": "Restaurante italiano",
  "jewelry_store": "Joyería",
  "language_school": "Academia de idiomas",
  "lawyer": "Abogado",
  "legal_services": "Servicios jurídicos",
  "locksmith": "Cerrajero",
  "lodging": "Alojamiento",
  "marketing_agency": "Agencia de marketing",
  "massage_therapist": "Masajista",
  "medical_clinic": "Clínica médica",
  "moving_company": "Empresa de mudanzas",
  "music_school": "Escuela de música",
  "nail_salon": "Salón de manicura",
  "notary_public": "Notaría",
  "nutritionist": "Nutricionista",
  "optician": "Óptica",
  "painter": "Pintor",
  "pet_store": "Tienda de mascotas",
  "pharmacy": "Farmacia",
  "photographer": "Fotógrafo",
  "physical_therapist": "Fisioterapeuta",
  "pizza_restaurant": "Pizzería",
  "plumber": "Fontanero",
  "preschool": "Guardería",
  "psychologist": "Psicólogo",
  "real_estate_agency": "Agencia inmobiliaria",
  "restaurant": "Restaurante",
  "roofing_contractor": "Tejados y cubiertas",
  "shipping_service": "Servicio de envíos",
  "shoe_repair_shop": "Reparación de calzado",
  "shoe_store": "Zapatería",
  "software_company": "Empresa de software",
  "spa": "Spa",
  "supermarket": "Supermercado",
  "tailor": "Sastre",
  "tax_consultant": "Asesor fiscal",
  "tour_operator": "Operador turístico",
  "travel_agency": "Agencia de viajes",
  "tutoring_service": "Academia de refuerzo",
  "veterinary_care": "Veterinario",
  "website_designer": "Diseñador de páginas web",
  "wedding_planner": "Organizador de bodas",
  "yoga_studio": "Estudio de yoga",
}
